import { getUserContext } from "../../../auth/auth-context";
import { parse } from "../../../utils/json-util";

export function FinancialYear() {
  const userContext = getUserContext();
  const { financialYear } = parse(userContext);

  return <div>FY({financialYear.name})</div>;
}
